import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import {
  Document,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import CollapsableList from '../../molecules/CollapsableList';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import SideNavBarTile from '../../molecules/SideNavBarTile';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';

export interface PlaybookSideBarProps {
  playbookData: any;
   
  handleSearchChange: (searchText: string) => void;
}

const PlaybookSideBar: React.FC<PlaybookSideBarProps> = ({
  playbookData,
  handleSearchChange,
}) => {
  const useStyles = makeStyles()({
    main: {
      width: '400px',
      backgroundColor: '#fff',
      position: 'fixed',
      top: '60px',
      left: 0,
      height: 'calc(100vh - 60px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRight: '1px solid #E5E9F0',
      overflowY: 'auto',
      overflowX: 'hidden',
      ...scrollBarStyles,
    },
    root: {
      width: '400px',
      marginTop: '1rem',
    },
    tileGrid: {
      width: '100%',
      margin: '0px 0px 12px 0px',
    },
    iconStyle: {
      height: '24px',
      width: '24px',
    },
    label: {
      fontWeight: 500,
      fontSize: '14px',
      color: patientAccessTheme.palette.text.highemphasis,
      lineHeight: '24px',
    },
    titleLabel: {
      fontWeight: 600,
      fontSize: '14px',
      color: patientAccessTheme.palette.text.highemphasis,
      lineHeight: '24px',
    },
    ellipses: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '250px',
      whiteSpace: 'nowrap',
      '&:hover': {
        overflow: 'visible',
        whiteSpace: 'normal',
        height: 'auto',
      },
    },
  });

  const { classes } = useStyles();
  const [activeTabsArray, setActiveTabsArray] = useState<boolean[]>([]);

  const [searchText, setSearchText] = useState<string>('');

  const handleActiveDropdownTab = (tabIndex: number) => {
    const updatedTabsArray = [...activeTabsArray];
    updatedTabsArray[tabIndex] = !activeTabsArray[tabIndex];

    setActiveTabsArray(updatedTabsArray);
  };

  const handleChange = (event: any) => {
    setSearchText(event.target.value);
    handleSearchChange(event.target.value);
  };

  const subTiles = (clauses: string[], content: string[]) => {
    const other_data = content.map((clause) => (
      <SideNavBarTile
        label={clause}
        isActive={false}
        isOpen={true}
        rootStyles={{
          minWidth: '370px',
          margin: '0 0 0 12px',
        }}
        labelTextStyles={classes.label}
      />
    ));
    const clauses_data = clauses.map((clause) => (
      <SideNavBarTile
        label={
          <Typography
            fontSize="14px"
            textColor={patientAccessTheme.palette.text.highemphasis}
            lineHeight="24px"
            className={classes.ellipses}
          >
            {clause}
          </Typography>
        }
        isActive={false}
        isOpen={true}
        rootStyles={{
          minWidth: '370px',
          margin: '0 0 0 24px',
          height: 'fit-content',
        }}
      />
    ));
    return [...other_data, ...clauses_data];
  };

  const handleClickScrollDown = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
      const headerOffset = 70;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className={classes.main}>
      <TextField
        placeholder={'Search Standards'}
        height="40px"
        width="324px"
        startAdornment={
          <SimpleSearch
            height="20px"
            width="20px"
            stroke={patientAccessTheme.palette.text.lowemphasis}
          />
        }
        showStartAdornment={true}
        value={searchText}
        onChange={handleChange}
        inputPropsStyle={{ margin: '1rem 0' }}
      />
      <Grid container className={classes.root}>
        {playbookData.map((standard: any, index: number) => (
          <Grid
            className={classes.tileGrid}
            onClick={() => handleClickScrollDown(standard.standard_id)}
          >
            <CollapsableList
              mainTileLabel={standard.standard_id}
              subTiles={subTiles(standard.clauses, standard.content)}
              isOpen={true}
              icon={
                <div style={{ height: '24px', width: '24px' }}>
                  <Document className={classes.iconStyle} />
                </div>
              }
              handleDropDownClick={() => {}}
              handleActiveDropdownTab={handleActiveDropdownTab}
              currentState={activeTabsArray[index]}
              tabIndex={index}
              sideNavBarTileRootStyles={{
                width: '400px',
                color: patientAccessTheme.palette.text.highemphasis,
                padding: '0.5rem',
                height: 'fit-content',
              }}
              sideNavBarLabelTextStyles={classes.titleLabel}
              width="400px"
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PlaybookSideBar;
